import {
  LANGUAGES,
  TLanguages,
} from 'components/logic/LanguageProvider/types/language-provider.interface';

export const isCorrectLanguage = (lng: string | null): lng is TLanguages =>
  lng === LANGUAGES.ENG ||
  lng === LANGUAGES.RUS ||
  lng === LANGUAGES.ESP ||
  lng === LANGUAGES.DEU ||
  lng === LANGUAGES.ITA;
